/* tslint:disable*/
import { Component, OnInit, Input, Renderer2, ViewChild, ElementRef } from '@angular/core';
import { DataService } from 'src/app/shared/services/data.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { productitems } from '../../classes/productitems';
import { Router } from '@angular/router';
import {
  MatSnackBar
} from '@angular/material/snack-bar';
import { Orders } from '../../classes/orders';
import { orderitem } from '../../classes/orderitem';
import { toWordsconver } from 'src/app/shop/checkout/utils/utils';
import { NaviFreshMartService } from 'src/app/shared/services/navi-fresh-mart.service';
import { paymentdetails } from '../../classes/paymentdetails';
import { WindowRefService } from 'src/app/window-ref.service';
import swal from 'sweetalert';
import {prepaymentcheck} from '../../classes/prepaymentcheck';
import { prodslistpaymentcheck } from '../../classes/prepaymentcheck';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
@Component({
  selector: 'app-footer-one',
  templateUrl: './footer-one.component.html',
  styleUrls: ['./footer-one.component.scss']
})
export class FooterOneComponent implements OnInit {
  selectedIcon:string = 'home';
  @Input() class: string = 'footer-light mt-2' // Default class 
  @Input() themeLogo: string = 'assets/images/icon/logo.png' // Default Logo
  @Input() themeIcon: string = 'favicon.ico';
  @Input() fssaiLogo: string = 'assets/images/FSSAI_logo.png'
  @Input() newsletter: boolean = true; // Default True
cartCount :number=0;
  public today: number = Date.now();
modalReference:any;
cartObj:any;
cartItems: productitems[] = [];
qrCodeResult:string= '';
isContainerVisible:boolean=false;
linePosition: number = 0;
ngClassForButtons="openCamera";
interval:any;
isSearchDisable:boolean;
printDetails:any;
totalPrice:number;
grandTotal:number;
totalGST:number;
gstPercent:number=5;
deliveryCharges:number=0;
printDate:any;
printPriceInWords:any;
printPaymentMode:any;
createdOrderId:number;
user:any;
totalCartItems:any;
@ViewChild("OrderSuccess",{static:true}) OrderSuccess:ElementRef;
orderDetails:Orders;
progressValue:number = 0;
dispenseType:string="";
orderedProductItems:productitems[]=[];
verificationId:string="";
machineSlotDetails= [];
validationResponse:prepaymentcheck;
itemImgLoc = './assets/images/genieImages/';
  constructor(private dataService: DataService,
     private router: Router,
      private modalService: NgbModal,
      private renderer: Renderer2,
      private _snackBar: MatSnackBar,
      private naviService: NaviFreshMartService,
      private winRef: WindowRefService,) { }

  ngOnInit(): void {
    this.user = JSON.parse(localStorage.getItem('user'));
    this.totalCartItems = this.dataService.getCartItemCount();
    this.dataService.cartCount$.subscribe((cartCount) =>{
this.cartCount = cartCount;
    });
    this.dataService.$isSearchDisableObs.subscribe((isSearchDisable)=>{
      this.isSearchDisable=isSearchDisable;
    });
    // only for genie
    const payload = {
      machineId: "48"
    }
    // this.naviService.GetVmsMachineSlots(payload).subscribe((data)=>{
      
    // })
    
    
  }
  OnCartClick(modal){
    this.cartItems = this.dataService.getCartItems();
    this.cartObj = this.dataService.getCartItemCount();
    this.modalReference = this.modalService.open(modal);

  }
  decrementCartItem(item: productitems){
 
    item.itemCount = item.itemCount -1;
    item.totalPrice = item.itemCount * item.offerPrice;
    if(item.itemCount ==0){

      item.isShown=false;
     this.dataService.delCartItemObj(item);
    }
    this.UpdateLocalStorage(item);
    this.cartItems = this.dataService.getCartItems();
    this.dataService.setCartCount(this.dataService.getCartCount() -1);
    this.cartObj = this.dataService.getCartItemCount();
  }
  UpdateLocalStorage(product: productitems){
    const genieItems = localStorage.getItem('genieCartItems');
    if(genieItems){
      const genieItemsArray : productitems[] = JSON.parse(genieItems);
      genieItemsArray.forEach((prod)=>{
        if(prod.prodId == product.prodId){
          prod.isShown = product.isShown;
          prod.itemCount = product.itemCount;
          prod.totalPrice = product.totalPrice;
        }
      });
      this.dataService.setCartItems(genieItemsArray);
    }
  }
  incrementCartItem(item: productitems){
  
    if(item.itemCount>=item?.balanceCountInStall){
      this._snackBar.open('Available Quantity Exceeded', 'Close',{

      });
      return 
    } 
    item.itemCount = item.itemCount + 1;
    item.totalPrice = item.itemCount * item.offerPrice;
    // because of updating count in local storgae
   
  //  this.UpdateLocalStorage(item);
    this.dataService.setCartCount(this.dataService.getCartCount() + 1);
    this.cartObj = this.dataService.getCartItemCount();
  }
  deleteCartItem(cartproducts: productitems){
    this.dataService.setCartCount(this.dataService.getCartCount()- cartproducts?.itemCount);
    cartproducts.itemCount = 0;
    cartproducts.totalPrice = 0;
    cartproducts.isShown=false;
    this.dataService.delCartItemObj(cartproducts);
    this.cartObj = this.dataService.getCartItemCount();
    this.cartItems = this.dataService.getCartItems();
    }
  changeIconColor(path:string, icon: string): void {
    this.selectedIcon = icon;
     if(localStorage.getItem('user') && localStorage.getItem('loginType')){
      this.router.navigateByUrl(`${path}`, {skipLocationChange:true});
     }
     else{
       this.router.navigate(['landscreen'],{skipLocationChange:true});
     }
       
     
      
  
    
  }
  OnCheckout(){
    
    // this search disable actually for coroporte login and uuid based 
    // temporarily showing direct razorpay after checkout
    // if(this.isSearchDisable){
      this.checkPrePaymentValidation().subscribe((isValid:boolean)=>{
        if(isValid) {
          console.log("true");
          this.modalReference.close();
           this.PlaceOrder();
        }
        else {
          let message = "";
          let cartItems :productitems[] = this.dataService.getCartItems();
          cartItems.forEach((cartitem)=>{
            this.validationResponse.productsList.forEach((prod)=>{
              if(cartitem.prodId==prod.prodId && prod.stockAvbl==false){
               
                prod.textToShow=` ${cartitem.prodName} has only ${prod.avblCount} items`;
                console.log("prodName", prod.textToShow);
                message = `${message}${prod.textToShow}`;
              }
            })
          })
          
          this._snackBar.open(message,'Close',{
            panelClass: 'custom-snackbar',
          });
          // to update itemCount in the cart to the available count
          cartItems.forEach((cartitem)=>{
            this.validationResponse.productsList.forEach((prod)=>{
              if(cartitem.prodId==prod.prodId && prod.stockAvbl==false){
               cartitem.itemCount=prod.avblCount;
              }
            })
          });
          this.dataService.setCartItems(cartItems);
        }
      })
      
    // un comment the below line to go to checkout page for normal old way
    // else this.router.navigateByUrl("shop/checkout", {skipLocationChange: true});
    
  }
  checkPrePaymentValidation():Observable<boolean>{
    this.validationResponse = {};
    let cartItems: productitems[] = this.dataService.getCartItems();
    let productsList :prodslistpaymentcheck[]  = [];
    cartItems.forEach((prod)=>{
      const payload :any = {};
      payload.prodId = prod.prodId,
      payload.rackId = prod.rackId,
      payload.slotId = prod.slotId,
      payload.selectedCount = prod.itemCount,
      productsList.push(payload);
    });
    const payload: prepaymentcheck = {
      genieId: cartItems[0].genieId,
      productsList: productsList
    }
   return this.naviService.checkPrePaymentValidation(payload).pipe(map((data: prepaymentcheck) => {
    const response = data;
    this.validationResponse = data;
    return response.productsList.every((prod) => prod.stockAvbl);
  }));
  }
  simulateProgress() {
    const totalSteps = 50; // Adjust this based on the granularity of progress you want
    const progressInterval = 5000 / totalSteps; // 5 seconds divided by total steps

    const progressUpdater = setInterval(() => {
      this.progressValue += (100 / totalSteps);
      
      if (this.progressValue >= 100) {
        clearInterval(progressUpdater); // Stop the progress when it reaches 100%
      }
    }, progressInterval);
  }
  PlaceOrder() {
    let user = JSON.parse(localStorage.getItem('user'));
    const mobileNumber = user.mobileNumber;
    // const vendorObj = this.usersList.find(obj=> obj.mobile==mobileNumber);
   
    let cartItems: productitems[] = this.dataService.getCartItems();
    let totalCartItems = this.dataService.getCartItemCount();
    
 
    console.log('user:' + user);
    console.log(cartItems);

    /**
     * need to prepare order and orderitmes to post
     */
    // if(this.createdOrderId!=0){
    //   this.UpdateRazorPayOrder();
    // }
    let orderitempaload: orderitem[] = [];

    for (let i = 0; i < cartItems.length; i++) {
      let cartItemsObj: productitems = cartItems[i];
      let orderItemObj: orderitem = {};
      orderItemObj.discountAmount = cartItemsObj?.discount;
      orderItemObj.itemId = cartItemsObj?.prodId;
      orderItemObj.itemName = cartItemsObj?.prodName;
      orderItemObj.itemImgLoc = cartItemsObj?.itemImgLoc;
      orderItemObj.itemPrice = cartItemsObj?.offerPrice;
      orderItemObj.orderId = 0;
      orderItemObj.quantity = cartItemsObj?.itemCount;
      orderItemObj.totalPrice = cartItemsObj?.totalPrice;
      orderItemObj.shopId = 11;
      orderItemObj.vendorId = 1001;
      //orderItemObj.itemImage = cartItemsObj?.prodImage;
      orderItemObj.uom = cartItemsObj?.uom;
      orderItemObj.gst = cartItemsObj?.gst;
      orderItemObj.packSize = cartItemsObj.packSize;
      orderItemObj.gstAmount = cartItemsObj?.offerPrice * this.gstPercent / 100;
      orderItemObj.rackId = cartItemsObj.rackId;
      orderItemObj.slotId = cartItemsObj.slotId;
      this.totalGST = Number((this.totalGST + Number(orderItemObj.gstAmount)).toFixed(2))
      orderitempaload.push(orderItemObj);
    }
    let orderpayload: Orders = {};
    orderpayload.orderItems = orderitempaload;
    orderpayload.accountId = user.accountId;
    orderpayload.amount = totalCartItems?.totalPrice;
    orderpayload.deliverCharges = this.deliveryCharges;
    orderpayload.deliveryDateTime = new Date();
    orderpayload.mobileno = user.mobileNumber;
    orderpayload.orderId = 0;
    orderpayload.orderDateTime = new Date();
    orderpayload.orderItemCount = totalCartItems?.totalCount;
    orderpayload.orderStatus='Created';
    orderpayload.paymentStatus='Unpaid';
    // if(this.paymentMode === "online") {
    //   orderpayload.orderStatus = 'Created';
    //   orderpayload.paymentStatus = 'Unpaid';
    // } else if(this.paymentMode === "cash") {
    //   orderpayload.orderStatus = 'InProcess';
    //   orderpayload.paymentStatus = 'Paid';
    // } else if(this.paymentMode === "cashAtStall" || this.paymentMode === "paytmAtStall") {
    //   orderpayload.orderStatus = 'Submitted';// TODO- Submitted or Delivered
    //   orderpayload.paymentStatus = 'Unpaid';// TODO - Unpaid or Paid
    // }
    orderpayload.paymentAmount = totalCartItems?.totalPrice;
    orderpayload.paymentMode = 'online';
    orderpayload.shippingAddressName="";
    // orderpayload.shippingAddressName = this.checkedAddress.doorNo + ", " + this.checkedAddress.landmark + ", " + this.checkedAddress.locality +
    //   ", " + this.checkedAddress.city + ", " + this.checkedAddress.state + ", " + this.checkedAddress.pincode;
    // orderpayload.billingAddressName = orderpayload.shippingAddressName;
    //orderpayload.subId = '1';
    orderpayload.shopId =11;
    orderpayload.vendorId =  1001;
    orderpayload.stallId = cartItems[0].stallId;
    orderpayload.subCatId = cartItems[0].subCatId;
    orderpayload.subCatName = cartItems[0].subCatName;
    orderpayload.genieId = cartItems[0].genieId;
    orderpayload.totalDiscount = totalCartItems?.discount;
    let that = this;
    this.printDetails = orderpayload.orderItems;
    this.totalPrice = Number((orderpayload.paymentAmount - this.totalGST).toFixed(2))
    this.grandTotal = Number((this.totalPrice + this.totalGST).toFixed(2))
    const todate = orderpayload.deliveryDateTime.getDate();
    const tomonth = orderpayload.deliveryDateTime.getMonth() + 1;
    const toyear = orderpayload.deliveryDateTime.getFullYear();
    const original_date = tomonth + '/' + todate + '/' + toyear;
    this.printDate = original_date;
    this.printPriceInWords = toWordsconver(this.grandTotal);
    this.printPaymentMode = orderpayload.paymentMode;

    this.naviService.postOrder(orderpayload).subscribe((data) => {
      orderpayload.orderId = data.orderId;
      this.createdOrderId = data.orderId // this global variable is for handling close button in rzr pay
      orderpayload.orderItems = data.orderItems;
     
      
        /** razor pay integration starts */
        let checkoutOBJ = {
          id: '',
          entity: 'Order',
          amount: 100 * (totalCartItems?.totalPrice + this.deliveryCharges),
          amount_paid: 100 * (totalCartItems?.totalPrice + this.deliveryCharges),
          amount_due: 0,
          currency: 'INR',
          receipt: data.orderId,
          status: '',
          attempts: 0,
          notes: '',
          created_at: new Date(),
        
        
        };
        // tslint:disable-next-line: align
        this.naviService
          .createRazorPayOrder(checkoutOBJ)
          .subscribe((response1) => {
            checkoutOBJ = response1;
            orderpayload.orderDateTime = checkoutOBJ.created_at;
            console.log('Response: ', checkoutOBJ);
            // let that = this;
            //call razor pay service
            let options = {
              key: 'rzp_live_JWNTCervxwP0Hj', // Enter the Key ID generated from the Dashboard
              amount: checkoutOBJ.amount.toString(), // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
              currency: 'INR',
              name: 'Navi Freshmart',
              description: 'Payment for Order : ' + orderpayload.orderId,
              image: '',
              order_id: checkoutOBJ.id, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
              config: {
                display: {
                  blocks: {
                    banks: {
                      name: 'Default Payment Methods',
                      instruments: [
                       
                        {
                            method: 'upi',
                            flows: ['qr']
                        }
                       
                        ],
                    },
                    other:{
                      name: "Other Payment Methods",
                      instruments: [
                        {
                          method: 'wallet',
                          wallets: ['paytm']
                        },
                        {
                          method: 'upi'
                        },
                        {
                          method: 'netbanking',
                          
                        },
                        {
                          method: 'card'
                        }
                      ]
                    }
                  },
                  sequence: ['block.banks','block.other'],
                  preferences: {
                    show_default_blocks: false,
                  },
                },
              },
            
              handler: function (response) {
                console.log(response.razorpay_payment_id);
                console.log(response.razorpay_order_id);
                console.log(response.razorpay_signature);

                let razororderId = response.razorpay_order_id;
                let signature = response.razorpay_signature;
                let signPayload = {
                  data:
                    response.razorpay_order_id +
                    '|' +
                    response.razorpay_payment_id,
                };
                that.naviService
                  .getSignature(signPayload)
                  .subscribe((data) => {
                    let productitemsArr: productitems[] = [];
                    that.cartItems = productitemsArr;
                    let totalCartItemsObj: productitems = {};
                    that.totalCartItems = totalCartItemsObj;
                    localStorage.setItem(
                      'totalCartItems',
                      JSON.stringify(totalCartItemsObj)
                    );
                    localStorage.setItem(
                      'actcartItems',
                      JSON.stringify(productitemsArr)
                    );
                    console.log(data, signature, data === signature);
                    let titleMsg = 'Order Success!';
                    let detailMsg = '';
                    let payobj: paymentdetails = {
                      orderId: orderpayload.orderId,
                      pgOrderId: response.razorpay_order_id,
                      pgpaymentId: response.razorpay_payment_id,
                      pgSignature: response.razorpay_signature,
                      pgStatus: "success",
                      type: 'razorpay',
                      pgResponse: JSON.stringify(response),
                    };
                    let isOrderSuccess=false;
                    //signature = signature + 'test';
                    if (data.data !== signature) {
                     
                      orderpayload.paymentStatus = 'Unpaid';
                      payobj.pgStatus = 'Invalid';
                      titleMsg = 'Order is Not Successfull!';
                      detailMsg = 'OrderId: ' + orderpayload?.orderId + ' created, But Payment not verified!';
                      this.orderId = 0;
                    } else {
                      orderpayload.paymentStatus = 'Paid';
                      orderpayload.orderStatus = 'InProcess';
                      isOrderSuccess=true;
                      this.createdOrderId = 0;
                      detailMsg = 'OrderId: ' + orderpayload?.orderId + ' created successfully!';
                    }
                    that.naviService
                      .postOrder(orderpayload)
                      .subscribe((data) => {
                        that.naviService
                          .savePaymentDetails(payobj)
                          .subscribe((paydata) => {
                            // localStorage.removeItem('actcartItems');
                            //   localStorage.removeItem('totalCartItems');
                            //   localStorage.removeItem('payload');
                            //   that.router.navigate(['shop/navimart']);
                            swal({
                              title: titleMsg,
                              text: detailMsg,
                              icon: 'success',
                            }).then(() => {
                              that.createdOrderId = 0;
                              const array : productitems[] = [];
                              that.orderedProductItems = that.dataService.getCartItems();
                              that.dataService.setCartCount(0);
                              that.dataService.setCartItems(array);
                              localStorage.removeItem('genieCartItems');
                              localStorage.removeItem('totalCartItems');
                              localStorage.removeItem('payload');
                              if(isOrderSuccess){
                                that.modalReference = that.modalService.open(this.OrderSuccess);
                                that.orderDetails = orderpayload;
                                that.simulateProgress();
                              }
                              // that.router.navigate(['']).then(() => {
                              //   window.location.reload();
                              // });
                              /*that.router.navigate(['/shop/' + that.shopName]).then(()=>{
                                window.location.reload();
                              });*/
                              // that.router.navigate(['shop/navimart']);
                            });
                          });
                      });
                  });
              }.bind(this),
              prefill: {
                name: this.user.userName,
                email: this.user.email,
                contact: this.user.mobileNumber,
              },
              notes: {
                address: 'Razorpay Corporate Office',
              },
              theme: {
                color: '#3399cc',
              },
            };
            const rzp1 = new this.winRef.nativeWindow.Razorpay(options);
            rzp1.open();
            rzp1.on('payment.failed', function (response) {
              orderpayload.paymentStatus = 'Unpaid';
              
              that.naviService
                .postOrder(orderpayload)
                .subscribe((data) => {
                  let payobj: paymentdetails = {
                    orderId: orderpayload.orderId,
                    pgOrderId: response.error.metadata.order_id,
                    pgpaymentId: response.error.metadata.payment_id,
                    pgSignature: '',
                    pgStatus: 'failed',
                    type: 'razorpay',
                    pgResponse: JSON.stringify(response),
                  };
                  that.naviService
                    .savePaymentDetails(payobj)
                    .subscribe((paydata) => {
                    
                        swal({
                          title: 'Payment Failed',
                          text:
                            'OrderId:' +
                            data.orderId +
                            ' created and Paymenttt Failed!',
                          icon: 'error',
                        }).then((result) => {
                          console.log("swal result", result);
                        that.createdOrderId=0;
                        console.log(that.createdOrderId);
                      
                          const array : productitems[] = [];
                                that.dataService.setCartCount(0);
                                that.dataService.setCartItems(array);
                          localStorage.removeItem('genieCartItems');
                          localStorage.removeItem('totalCartItems');
                          localStorage.removeItem('payload');
                          that.router.navigate([""],{skipLocationChange:true});
                          // that.router.navigate(['/pages/my-orders'],{skipLocationChange: true});
                          /*that.router.navigate(['/shop/' + that.shopName]).then(()=>{
                            window.location.reload();
                          });*/
                          // that.router.navigate(['shop/navimart']);
                        });
                     
                    
                    });
                });
              /*alert(response.error.code);
              alert(response.error.description);
              alert(response.error.source);
              alert(response.error.step);
              alert(response.error.reason);
              alert(response.error.metadata.order_id);
              alert(response.error.metadata.payment_id);*/
            });
          });
        /** razor pay integration ends */
      
    });
  }
  OnDispense(){
  
    // get the machine and get slots later
    if(this.orderedProductItems.length > 0){
      this.orderDetails.orderItems.forEach((item)=>{
       this.orderedProductItems.forEach((orderitem)=>{
         if(item.itemId==orderitem.prodId){
           // get the ordered products slotid, row, col
         }
       })
      });
      this.modalReference.close();
      this.orderDetails.orderStatus="Completed"; // for setting reserved to sale
      this.naviService.postOrder(this.orderDetails).subscribe((data)=>{
        console.log("order data",data);
        const titleMsg ="Success";
        const detailMsg = "Order Dispensed Successfully";
        swal({
          title: titleMsg,
          text: detailMsg,
          icon: 'success',
        }).then(()=>{
          this.router.navigate([''],{skipLocationChange:true});
        });
      });
     
      // then open scanner
    }
   
  }
  UpdateRazorPayOrder(){
    let razorPayOrder = {

    }
  }
  animateLine() {
   this.interval =  setInterval(() => {
      this.linePosition += 1;
      if (this.linePosition >= 100) {
        this.linePosition = 0;
      }
    }, 10); // Adjust the interval as needed
  }
  scan(modal){
    this.modalReference = this.modalService.open(modal,{keyboard:false,backdrop:'static'});
    this.animateLine();
    setTimeout(()=>{
      // Automatically triggering Integrated web cam button to open camera
        const buttons = document.querySelectorAll('.buttonDiv');
        const targetElement = buttons[1].querySelector('.openCamera') as HTMLElement;
        targetElement.click();
       
        this.isContainerVisible = true;
       // Hiding Stop Camera button
        const hidebutton = document.querySelectorAll('.openCamera');
        Array.from(hidebutton).forEach(button => {
          this.renderer.setStyle(button, 'display', 'none');
        });      
    },2000)
   
  }
  capturedQr(result: string){
    // this.isqrscanner=true;
  
    console.log(result);
    this.qrCodeResult = result;
    this.verificationId = result;
    this.isContainerVisible = false;
    // call the api again 
   
  }
  OnClose(){
    this.modalReference.close();
    this.isContainerVisible = false;
    this.qrCodeResult = '';
    this.ngDestroy(this.interval);
    // const stop = document.querySelectorAll('.openCamera');
    // const stopCamera = stop[2].querySelector('.openCamera') as HTMLElement;
    // stopCamera.click();
  } 
  onError(error){
    console.log(error);
    }
    ngDestroy(interval){
      clearInterval(interval);
    }
}
